export default __webpack_public_path__ + "static/media/Mark-3-HUD-14.f7074437.jpg";